import React, { useState, useEffect } from 'react';
import { Select, Button, Table, Modal } from 'antd';
import { connect } from 'react-redux';
import { Actions } from '../../store/actions';
import { SearchOutlined } from '@ant-design/icons';
import Util from '../../util';

const LeadsManagement = ({ stats, dealers, dealerCars, fetchStats, getDealers, getDealersCars }) => {
	const [editModal, setEditModal] = useState(false);
	const [selectedDealer, setSelectedDealer] = useState('');

	function dataCalls() {
		getDealersCars(selectedDealer);
		fetchStats(selectedDealer);
	}

	useEffect(() => {
		getDealers();
	}, []);

	const renderDealersList = () => {
		if (dealers?.length > 0)
			return dealers.map((dealer) => (
				<Select.Option key={dealer._id} value={dealer._id}>
					{dealer.dealershipName} / {dealer.username}
				</Select.Option>
			));
	};

	const columns = [
		{
			title: 'Name',
			key: 'name',
			render: function action(text, record) {
				return (
					<div>
						<a
							href={`https://carmandee.com/${record.category}s/${record.type}/${record.id}`}
							target="_blank"
							rel="noopener noreferrer"
						>
							<p key={record?.name}>{record?.name}</p>
						</a>
					</div>
				);
			},
		},
		{
			title: 'Posted',
			key: 'createdAt',
			render: function action(text, record) {
				return <p key={record?.createdAt}> {`${Util.timeSince(record?.createdAt)}` + ` ` + `ago`}</p>;
			},
		},
		{
			title: 'Status',
			key: 'status',
			filterIcon: function filter(filtered) {
				return <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />;
			},
			filters: [
				{
					text: 'Active',
					value: 1,
				},
				{
					text: 'Inactive',
					value: 0,
				},
				{
					text: 'All',
					value: 3,
				},
			],

			filterMultiple: false,
			onFilter: (value, record) =>
				value === 3
					? record?.status === 1 || record?.status === 0 || record?.status === 2 || record?.status === 3
					: record?.status === value,

			render: function action(text, record) {
				return (
					<p key={record?.status}>
						{' '}
						{record?.status === 1 ? 'Active' : record?.status === 0 ? 'Inative' : record.status === 2 ? 'Sold' : ''}
					</p>
				);
			},
		},
		{
			title: 'Views',
			dataIndex: 'numberOfViews',
			key: 'numberOfViews',
		},
		{
			title: 'Call Clicks',
			dataIndex: 'numberOfCallClicks',
			key: 'numberOfCallClicks',
		},
	];

	return (
		<div className="lead-section">
			<div className="selector">
				<Select
					className={selectedDealer ? 'filled-field' : ''}
					placeholder="Dealer"
					dropdownStyle={{ zIndex: 0 }}
					onSelect={(val) => setSelectedDealer(val)}
					showSearch
					allowClear
					optionFilterProp="children"
				>
					{renderDealersList('Dealers')}
				</Select>
				<div className="search-button">
					<Button onClick={() => dataCalls()} size="small" style={{ width: 90 }}>
						Search
					</Button>
				</div>
			</div>
			<div className="stats-part">
				<div className="part">
					<p> Total Ads Active / Lifetime </p>
					<p className="left-values">
						{stats ? stats?.totalActiveVehicles : '-'} / {stats ? stats?.totalVehicles : '-'}
					</p>
				</div>
				<div className="part">
					<p> Total Ad Views Active / Lifetime</p>
					<p className="left-values">
						{stats?.totalActiveViews?.length > 0 ? stats?.totalActiveViews[0].totalViews : '-'} /{' '}
						{stats?.totalViews?.length > 0 ? stats?.totalViews[0].totalViews : '-'}
					</p>
				</div>
				<div className="part">
					<p> Total Calls Active / Lifetime </p>
					<p className="left-values">
						{stats?.totalActiveCallClicks?.length > 0 ? stats?.totalActiveCallClicks[0].totalNumberOfCallClicks : '-'} /{' '}
						{stats?.totalCallClicks?.length > 0 ? stats?.totalCallClicks[0].totalNumberOfCallClicks : '-'}{' '}
					</p>
				</div>
			</div>
			<div>
				<Table
					dataSource={dealerCars}
					columns={columns}
					rowKey={(record) => record._id}
					size="small"
					scroll={{ x: true }}
				/>
			</div>
		</div>
	);
};

const mapStateToProps = (store) => ({
	dealers: store.leads.dealers,
	dealerCars: store.leads.dealerCars,
	stats: store.leads.stats,
});

const mapDispatchToProps = (dispatch) => ({
	getDealers: () => dispatch(Actions.fetchDealers()),
	getDealersCars: (query) => dispatch(Actions.fetchDealerCars(query)),
	fetchStats: (query) => dispatch(Actions.fetchStats(query)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LeadsManagement);
